import { gql } from "@apollo/client";

export const enableCameraKitForVersion = gql`
    mutation EnableCameraKitFeature($appId: String!, $sourceVersion: Int!) {
        enableCameraKitFeature(input: { appId: $appId, sourceVersion: $sourceVersion }) {
            _
        }
    }
`;
